/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// $( ".Popover__Value" ).click(function() {
//    window.esc_now_back_in_stock.triggerRefresh()
// });

document.addEventListener("DOMContentLoaded", function() {
  // Read More Read Less Description for multiple elements
  $('.an__description').each(function(index, element) {
    var description = $(element);
    var button = description.siblings('.read-more-button');
    var content = description.text().trim().split(/\s+/); // Split content into words
  
    var maxWords = 20; // Maximum number of words to show initially
    var collapsedContent = content.slice(0, maxWords).join(' ');
    var expanded = false;
  
    if (content.length > maxWords) { // Check if the content exceeds the maximum word count
      description.text(collapsedContent + '...');
      button.text('Read More');
      button.on('click', function() {
        if (!expanded) {
          description.text(content.join(' '));
          button.text('Read Less');
          expanded = true;
        } else {
          description.text(collapsedContent + '...');
          button.text('Read More');
          expanded = false;
        }
      });
    } else {
      button.hide(); // Hide the button if the content doesn't exceed the maximum word count
    }
  });
  
  // const refreshButtons = document.querySelectorAll('.QuantitySelector__Button, .CartItem__Remove');
  // let timeoutId = null;
  // const refreshPage = () => {
  //   if (timeoutId) {
  //     clearTimeout(timeoutId);
  //   }
  //   timeoutId = setTimeout(() => {
  //     location.reload();
  //   }, 1000);
  // }
  // refreshButtons.forEach(button => {
  //   button.addEventListener('click', refreshPage);
  // });
  
  
    setTimeout(function() {
      $('.jdgm-prev-badge__text').each(function(){
         var data = $(this).html();
         $(this).html(data+' Reviews'); 
      });
    },5000);
  
    $('.pr_meta_content').hide();
    $('.pr_description').click(function(){
      if($(this).hasClass('active')){
        $(this).removeClass('active');
        $(this).children('.pr_meta_content').slideUp();
      } else {
        $('.pr_description').removeClass('active');
        $('.pr_description').children('.pr_meta_content').slideUp();
        $(this).addClass('active');
        $(this).children('.pr_meta_content').slideDown();
      }
    });
  
    // $('.Product__Slideshow').flickity({
    //   // Set the options for the gallery slider
    //   cellAlign: 'left',
    //   contain: true,
    //   prevNextButtons: true,
    //   pageDots: false
    // });
    
    // $('.Product__SlideshowNav--thumbnails').flickity({
    //   // Set the options for the thumbnail slider
    //   asNavFor: '.Product__Slideshow',
    //   cellAlign: 'left',
    //   prevNextButtons: false,
    //   pageDots: false,
    //   draggable: true,
    // });
  });
  
  
  document.addEventListener('DOMContentLoaded', function() {
    var phoneBreakpointMaxWidth = 1199;
  
    function handleTabClick(e) {
      e.preventDefault();
      var tab = e.currentTarget;
      var parentLi = tab.parentElement;
  
      if (parentLi.classList.contains('hw--active')) {
        parentLi.classList.remove('hw--active');
        tab.nextElementSibling.style.display = 'none';
      } else {
        document.querySelectorAll('.tabs-list > li').forEach(function(li) {
          li.classList.remove('hw--active');
          li.querySelector('.tab-content').style.display = 'none';
        });
        parentLi.classList.add('hw--active');
        tab.nextElementSibling.style.display = 'block';
      }
    }
  
    function checkScreenSize() {
      var tabs = document.querySelectorAll('.tabs-list > li > .tab');
  
      if (window.innerWidth <= phoneBreakpointMaxWidth) { // Mobile view
        tabs.forEach(function(tab) {
          tab.addEventListener('click', handleTabClick);
        });
      } else { // Desktop view
        tabs.forEach(function(tab) {
          tab.removeEventListener('click', handleTabClick);
          // Optionally, re-bind for desktop behavior, if different
          tab.addEventListener('click', handleTabClick);
        });
      }
    }
  
    window.addEventListener('resize', checkScreenSize);
    checkScreenSize();
  });
  
  
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.tabs-list > li > .tab').forEach(function(element) {
        element.addEventListener('click', function(e) {
          // console.log('Link clicked');
            e.preventDefault();
          e.stopImmediatePropagation();
        });
    });
  });
  
  
  // The swatch/select sync that used to live here drove the `.custom-select` dropdown, whose markup
  // in product-form.liquid is commented out, so it matched nothing and only threw. The live swatch
  // and dropdown syncing is the `.dropdown-item` / `.swatch-view-item` code in product-form.liquid.

  // If there is no free gift applicable on PP start
  document.addEventListener('DOMContentLoaded', function() {
      if (document.querySelector('.Product__InfoWrapper .free-gift-pr')) {
          document.querySelector('.HW--Product-Overview-Main').classList.add('AN--NO--free-gift');
      }
  });
  // If there is no free gift applicable on PP end
  
   // Select the custom tag 'variant-swatch-king' Set visibility to 'visible' Start
  window.addEventListener('load', function() {
      var element = document.querySelector('variant-swatch-king');
      if (element) {     
          element.style.visibility = 'visible';
      }
  });
   // Select the custom tag 'variant-swatch-king' Set visibility to 'visible' End
  
  // FAQ START
  document.addEventListener('DOMContentLoaded', function() {
      const questions = document.querySelectorAll('.hw__faq .faq .question');
  
      questions.forEach((question) => {
          question.addEventListener('click', () => {
              const answer = question.nextElementSibling;
              const otherQuestions = document.querySelectorAll('.hw__faq .faq .question');
  
              otherQuestions.forEach((otherQuestion) => {
                  if (otherQuestion !== question) {
                      otherQuestion.parentNode.classList.remove('current');
                  }
              });
  
              question.parentNode.classList.toggle('current');
          });
      });
  });
  // FAQ END
  
  // ******************************************************************************
  // CONFIGURABLE SETTINGS
  const MIN_UNITS = 5;
  const MAX_UNITS = 20;
  
  // Default update interval: 0 hours, 1 minute
  let UPDATE_INTERVAL_HOURS = 24;
  let UPDATE_INTERVAL_MINUTES = 1;
  
  let countdownInterval;
  
  // UTILITY: Generate random number
  function getRandomUnits(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  
  // UPDATE NUMBER AND SAVE
  function updateUnitsSold() {
    const newUnits = getRandomUnits(MIN_UNITS, MAX_UNITS);
    document.getElementById("units_sold_number").textContent = newUnits;
    localStorage.setItem("lastUnits", newUnits);
    // console.log(`🟢 Units updated → ${newUnits}`);
  }
  
  // START COUNTDOWN
  function startCountdown(targetTime) {
    if (countdownInterval) clearInterval(countdownInterval);
  
    countdownInterval = setInterval(() => {
      const now = Date.now();
      const remaining = targetTime - now;
  
      if (remaining <= 0) {
        clearInterval(countdownInterval);
        // console.log("⏰ Time’s up! Updating units...");
        updateUnitsSold();
  
        // Schedule next update based on current interval
        const nextTarget = Date.now() + UPDATE_INTERVAL_HOURS * 60 * 60 * 1000 + UPDATE_INTERVAL_MINUTES * 60 * 1000;
        localStorage.setItem("nextUpdate", nextTarget);
        startCountdown(nextTarget);
        return;
      }
  
      const hrs = Math.floor(remaining / (1000 * 60 * 60));
      const mins = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((remaining % (1000 * 60)) / 1000);
  
      // console.log(`⏳ Next update in: ${hrs}h ${mins}m ${secs}s`);
    }, 1000);
  }
  
  // INITIALIZE
  document.addEventListener("DOMContentLoaded", () => {
    // Only the product template renders the counter; elsewhere this threw and left a 1s interval running.
    if (!document.getElementById("units_sold_number")) return;

    let lastUnits = localStorage.getItem("lastUnits");
    let nextUpdate = localStorage.getItem("nextUpdate");
  
    // FIRST EVER LOAD: No lastUnits in storage
    if (!lastUnits) {
      lastUnits = getRandomUnits(MIN_UNITS, MAX_UNITS);
      document.getElementById("units_sold_number").textContent = lastUnits;
      localStorage.setItem("lastUnits", lastUnits);
  
      // Set first next update
      nextUpdate = Date.now() + UPDATE_INTERVAL_HOURS * 60 * 60 * 1000 + UPDATE_INTERVAL_MINUTES * 60 * 1000;
      localStorage.setItem("nextUpdate", nextUpdate);
  
      // console.log(`🟡 First random units → ${lastUnits}`);
    } else {
      // SHOW last saved number
      document.getElementById("units_sold_number").textContent = lastUnits;
      // console.log(`🟡 Loaded units from storage → ${lastUnits}`);
    }
  
    // Start countdown toward next update
    startCountdown(parseInt(nextUpdate));
  });
  
  // FUNCTION TO CHANGE INTERVAL DYNAMICALLY
  function changeInterval(hours, minutes) {
    UPDATE_INTERVAL_HOURS = hours;
    UPDATE_INTERVAL_MINUTES = minutes;
  
    const nextTarget = Date.now() + UPDATE_INTERVAL_HOURS * 60 * 60 * 1000 + UPDATE_INTERVAL_MINUTES * 60 * 1000;
    localStorage.setItem("nextUpdate", nextTarget);
    // console.log(`🔄 Interval changed to ${hours}h ${minutes}m. Countdown reset.`);
    startCountdown(nextTarget);
  }
  
  // Product Overview Dropdown Functionality
  document.addEventListener('DOMContentLoaded', function() {
    const overviewTabs = document.querySelectorAll('.hw--product-overview-new .overview-tab-item');
    
    if (overviewTabs.length > 0) {
      overviewTabs.forEach(tab => {
        const tabLink = tab.querySelector('.tab-link');
        const tabContent = tab.querySelector('.tab-content');
        const tabIcon = tab.querySelector('.tab-icon');
        
        if (tabLink && tabContent) {
          tabLink.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Close all other tabs
            overviewTabs.forEach(otherTab => {
              if (otherTab !== tab) {
                otherTab.classList.remove('active');
                const otherContent = otherTab.querySelector('.tab-content');
                const otherIcon = otherTab.querySelector('.tab-icon');
                if (otherContent) {
                  otherContent.style.display = 'none';
                }
                if (otherIcon) {
                  const plusIcon = otherIcon.querySelector('.tab-icon-plus');
                  const minusIcon = otherIcon.querySelector('.tab-icon-minus');
                  if (plusIcon) plusIcon.style.display = 'block';
                  if (minusIcon) minusIcon.style.display = 'none';
                }
              }
            });
            
            // Toggle current tab
            if (tab.classList.contains('active')) {
              tab.classList.remove('active');
              tabContent.style.display = 'none';
              if (tabIcon) {
                const plusIcon = tabIcon.querySelector('.tab-icon-plus');
                const minusIcon = tabIcon.querySelector('.tab-icon-minus');
                if (plusIcon) plusIcon.style.display = 'block';
                if (minusIcon) minusIcon.style.display = 'none';
              }
            } else {
              tab.classList.add('active');
              tabContent.style.display = 'block';
              if (tabIcon) {
                const plusIcon = tabIcon.querySelector('.tab-icon-plus');
                const minusIcon = tabIcon.querySelector('.tab-icon-minus');
                if (plusIcon) plusIcon.style.display = 'none';
                if (minusIcon) minusIcon.style.display = 'block';
              }
            }
          });
        }
      });
    }
  });
  // ******************************************************************************
  
  // The ul/li dropdown that used to live here queried .custom-dropdown__selected /  __list /
  // __option, class names that appear nowhere in the theme, so it threw on the first
  // .custom-dropdown and aborted. product-form.liquid owns the live .dropdown-toggle /
  // .dropdown-menu / .dropdown-item dropdown.
